import React, { useState } from "react";
import PricingCard from "./PricingCard";
import pricetag from '../../../assets/icons/price-tag.svg'
import {plans} from '../../../assets/data/planData'

const PricingSection = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="py-20 bg-gradient-to-b from-btn-secondary-base/40 to-white">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center">
        <h2 className="text-4xl font-bold text-btn-primary text-center mb-4">Simple, Transparent Pricing</h2>
        <p className="text-lg text-btn-secondary-text text-center mb-10 max-w-2xl">No hidden fees. Cancel anytime. Try all features free for 30 days—no credit card required!</p>
        <img src={pricetag} alt="Pricing Visual" className="w-32 h-32 mx-auto mb-8" loading="lazy" />

        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {plans.map((plan) => {
            const isHighlighted = hovered ? (plan.name === hovered) : plan.highlight;

            return (
              <div
                key={plan.name}
                className="w-full"
                onMouseEnter={() => setHovered(plan.name)}
                onMouseLeave={() => setHovered(null)}
                onFocus={() => setHovered(plan.name)}
                onBlur={() => setHovered(null)}
                tabIndex={0}
              >
                <PricingCard plan={plan} highlight={isHighlighted} />
              </div>
            );
          })}
        </div>

        <div className="text-center text-btn-primary text-lg font-semibold mt-8" />
      </div>
    </section>
  );
};

export default PricingSection;
